import { TFunction } from "i18next";
import * as yup from "yup";

export const resetPasswordValidationSchema = (errorsT: TFunction) =>
  yup.object({
    email: yup.string().email(errorsT("string.email")).required(errorsT("required"))
  });
